<div class='d-flex justify-content-around'>
  <app-button
    (click)='onButtonClick()'
    [style]="'outline'"
    color='blue'
    size='small'
    text='Select'></app-button>
</div>
